export default [
    {path: ':crop_id/:form_id'},
    {path: ':crop_id/:form_id/:trial_station_id/:year/:season_id'},
    {path: ':crop_id/:form_id/:trial_station_id/:year/:season_id/edit/:variety_id/:entry_no'}
]